export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6951.47ab8ed5.jpg";